import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MenuButtonsComponent} from '../menu-buttons/menu-buttons.component';
import {ModalErrorComponent} from '../modal-error/modal-error.component';
import {CheckInAction} from '../../models/check-in-action';
import {ReservationService} from '../../../core/api/reservation.service';
import {CheckInFlowService} from '../../../core/services/check-in-flow.service';
import {Router} from '@angular/router';
import {HoomvipStorage} from '../../../core/hoomvip-storage/hoomvip-storage.service';
import {CheckInActionsService} from '../../../core/services/check-in-actions.service';

@Component({
  selector: 'modal-check-in-hosts-count',
  templateUrl: './modal-check-in-hosts-count.component.html',
  styleUrls: ['./modal-check-in-hosts-count.component.scss'],
  standalone: true,
  imports: [
    MenuButtonsComponent,
    ModalErrorComponent
  ]
})
export class ModalCheckInHostsCountComponent implements OnInit {

  @Input() showCloseButton: boolean = true;
  @Input() title!: string;
  @Input() pendingHostsCounts: number = 0;
  @Input() show: boolean = false;
  @Output() close = new EventEmitter<void>();

  checkinActions: CheckInAction[] = [];

  constructor(
    private reservationService: ReservationService,
    private checkInFlowService: CheckInFlowService,
    private router: Router,
    private hoomvipStorage: HoomvipStorage,
    private checkInActionsService: CheckInActionsService
  ) {

  }

  ngOnInit(): void {
    this.reservationService.getReservation().subscribe(reservation => {
      this.checkInFlowService.get(reservation).subscribe(checkInFlowData => {
        this.checkinActions = this.checkInActionsService.getCheckInActions(checkInFlowData);
      });
    });
  }

  closeModal(): void {
    this.close.emit();
  }

  onCheckinActionClick(action: any) {
    if (action.id === 'close') {
      this.closeModal();
    } else if (action.id === 'check-in-signature') {
      this.hoomvipStorage.setCheckInSignatureInfo(action.data.travelRegisterId, action.data.contractUrl, action.data.email);
      this.router.navigate(['/check-in-signature']);
    } else if (action.id === 'check-in-signature-minor') {
      this.hoomvipStorage.setCheckInMinorSignatureInfo(action.data.travelRegisterId, action.data.email);
      this.router.navigate(['/check-in-signature-minor']);
    } else {
      this.router.navigate([action.href]);
    }
  }
}
